import { render } from "./ImageAttachment.vue?vue&type=template&id=81dbf15a"
import script from "./ImageAttachment.vue?vue&type=script&lang=js"
export * from "./ImageAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__